export function renderPrayTogether(container) {
  if (!container) return;

  container.innerHTML = `
    <div class="pray-page">
      <!-- PrayTogether Hero -->
      <header class="studies-hero">
        <div class="wt-container text-center">
          <div class="studies-brand-pill" style="background:rgba(16, 185, 129, 0.15); color:var(--accent-emerald); border-color:rgba(16, 185, 129, 0.3);">
            <i class="fa-solid fa-hands-praying"></i>
            <span>PrayTogether</span>
          </div>
          <h1 class="studies-title">Walk Together Prayer App</h1>
          <p class="studies-subtitle">
            A purposeful, distraction-free Android application designed to help you cultivate a steadfast, daily prayer life anchored in scripture.
          </p>
        </div>
      </header>

      <main class="wt-container pray-layout">
        <!-- App Showcase Hero Card -->
        <div class="pray-showcase-card">
          <div class="pray-app-preview">
            <div class="pray-app-icon-wrap">
              <img src="/study/android-chrome-512x512-1.png" alt="PrayTogether Android App" class="pray-app-icon" />
              <div class="pray-android-badge">
                <i class="fa-brands fa-android"></i> Android App
              </div>
            </div>
            
            <div class="pray-app-info">
              <h2>PrayTogether for Android</h2>
              <p class="pray-app-tagline">“Pray without ceasing.” — 1 Thessalonians 5:17</p>
              
              <div class="pray-status-callout">
                <div class="status-indicator-dot"></div>
                <div>
                  <strong>APK File Staged:</strong> The app file slot is configured and ready. 
                  As soon as the APK is added, direct downloads will be immediately active.
                </div>
              </div>

              <div class="pray-cta-row">
                <a href="/downloads/praytogether.apk" class="btn-primary pray-download-btn" id="pray-apk-btn" download="PrayTogether.apk">
                  <i class="fa-brands fa-android"></i>
                  <span>
                    <strong>Download Android APK</strong>
                    <small>Version 1.0 • Direct Install</small>
                  </span>
                </a>

                <a href="#verses" class="btn-secondary">
                  <i class="fa-solid fa-layer-group"></i> Scripture Verses
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Key Features Grid -->
        <section class="pray-features-grid">
          <div class="pray-feature-card">
            <div class="feature-icon" style="color:var(--accent-emerald); background:rgba(16, 185, 129, 0.12);">
              <i class="fa-solid fa-bible"></i>
            </div>
            <h3>Scripture-Anchored Prayers</h3>
            <p>Pray God's promises back to Him with guided prompts from the Psalms, Paul's epistles, and Jesus' teachings.</p>
          </div>

          <div class="pray-feature-card">
            <div class="feature-icon" style="color:var(--accent-blue); background:rgba(59, 130, 246, 0.12);">
              <i class="fa-solid fa-list-check"></i>
            </div>
            <h3>Intercession Lists</h3>
            <p>Organize prayer requests for family, church leaders, cohorts, and community needs, with answered prayer tracking.</p>
          </div>

          <div class="pray-feature-card">
            <div class="feature-icon" style="color:var(--accent-gold); background:rgba(245, 158, 11, 0.12);">
              <i class="fa-solid fa-bell"></i>
            </div>
            <h3>Daily Prayer Rhythms</h3>
            <p>Build consistent prayer habits with customizable reminders for morning, noon, and evening prayer times.</p>
          </div>

          <div class="pray-feature-card">
            <div class="feature-icon" style="color:var(--accent-indigo); background:rgba(99, 102, 241, 0.12);">
              <i class="fa-solid fa-plane-slash"></i>
            </div>
            <h3>Distraction-Free & Offline</h3>
            <p>100% offline-first design. No ads, no social media feeds—just you and God in quiet fellowship.</p>
          </div>
        </section>

        <!-- Quick Prayer Guide -->
        <section class="pray-guide-card">
          <h2>The A.C.T.S. Prayer Rhythm</h2>
          <p class="pray-guide-intro">Use this simple biblical model as a foundation for daily prayer:</p>
          
          <div class="acts-grid">
            <div class="acts-col">
              <span class="acts-letter">A</span>
              <h4>Adoration</h4>
              <p>Praise God for who He is—His power, faithfulness, holiness, and love.</p>
            </div>
            <div class="acts-col">
              <span class="acts-letter">C</span>
              <h4>Confession</h4>
              <p>Humbly acknowledge sins and receive Christ’s forgiveness and cleansing.</p>
            </div>
            <div class="acts-col">
              <span class="acts-letter">T</span>
              <h4>Thanksgiving</h4>
              <p>Give genuine thanks for specific blessings, trials that build perseverance, and answers to prayer.</p>
            </div>
            <div class="acts-col">
              <span class="acts-letter">S</span>
              <h4>Supplication</h4>
              <p>Bring your requests and intercede boldly for family, discipleship, and world needs.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  `;

  // Check if apk exists or show helpful alert
  const apkBtn = document.getElementById('pray-apk-btn');
  if (apkBtn) {
    apkBtn.addEventListener('click', async (e) => {
      try {
        const headResp = await fetch('/downloads/praytogether.apk', { method: 'HEAD' });
        if (!headResp.ok) {
          e.preventDefault();
          showToast('The Android APK file will be available here once provided by Joe. Stay tuned!', 'info');
        }
      } catch (err) {
        e.preventDefault();
        showToast('The Android APK file will be available here once provided by Joe. Stay tuned!', 'info');
      }
    });
  }
}

function showToast(message, type = 'info') {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = `toast toast-${type}`;
  toast.innerHTML = `
    <i class="fa-solid fa-circle-info" style="margin-right:8px;"></i>
    <span>${message}</span>
  `;
  container.appendChild(toast);
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 300);
  }, 4000);
}
